module.exports = __webpack_public_path__ + "img/wjw.e60c72c6.png";